import { Link } from 'react-router-dom';
import { COOKIE_PREFS_EVENT } from '@/components/shared/CookieConsentBanner';
import { copyrightLine } from '@/config/legal';

const AppFooter = () => {
  // Re-open the cookie banner in detail mode so the user can revisit
  // their analytics opt-in choice without digging through Settings.
  const openCookiePreferences = () => {
    window.dispatchEvent(new Event(COOKIE_PREFS_EVENT));
  };

  return (
    <footer className="w-full py-4 px-6 border-t border-border/50 bg-background/50">
      <div className="max-w-[1600px] mx-auto flex flex-wrap items-center justify-center gap-4 text-xs text-muted-foreground">
        <span>{copyrightLine(new Date().getFullYear())}</span>
        <span className="hidden sm:inline">•</span>
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms of Service
        </Link>
        <span className="hidden sm:inline">•</span>
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy Policy
        </Link>
        <span className="hidden sm:inline">•</span>
        <Link to="/cookies" className="hover:text-foreground transition-colors">
          Cookie Policy
        </Link>
        <span className="hidden sm:inline">•</span>
        <button
          type="button"
          onClick={openCookiePreferences}
          className="hover:text-foreground transition-colors underline-offset-2"
        >
          Cookie preferences
        </button>
      </div>
    </footer>
  );
};

export default AppFooter;
